import * as Phaser from "phaser";
import { TelegramGlobalPlugin } from "$/game/plugins/TelegramGlobalPlugin.ts";

export type Settings = {
  isSoundEnabled: boolean;
  isMusicEnabled: boolean;
  isVibrationEnabled: boolean;
  notificationsEnabled: boolean;
  language: "ru" | "en";
  musicVolume: number;
};

// TODO: не забыть доделать
export class SettingsGlobalPlugin extends Phaser.Plugins.BasePlugin {
  private telegram!: TelegramGlobalPlugin;
  private settingsKey = "telegochi-settings";
  private settings: Settings = {
    isSoundEnabled: true,
    isMusicEnabled: true,
    isVibrationEnabled: true,
    notificationsEnabled: true,
    language: "en",
    musicVolume: 0.25,
  };

  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    this.telegram = pluginManager.game.plugins.get(
      "telegram",
    ) as TelegramGlobalPlugin;

    this.settings = JSON.parse(
      localStorage.getItem(this.settingsKey) || JSON.stringify(this.settings),
    );

    this.setSetting("language", this.telegram.LANG);
    localStorage.setItem(this.settingsKey, JSON.stringify(this.settings));
  }

  public getSetting = <K extends keyof Settings>(setting: K): Settings[K] => {
    return this.settings[setting];
  };

  public setSetting = <K extends keyof Settings>(
    setting: K,
    value: Settings[K],
  ) => {
    if (setting in this.settings) {
      this.settings[setting] = value;
    }
    localStorage.setItem(this.settingsKey, JSON.stringify(this.settings));
  };
}
